import { render, staticRenderFns } from "./Bilder.vue?vue&type=template&id=21c29354&"
import script from "./Bilder.vue?vue&type=script&lang=js&"
export * from "./Bilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports